<template>
  <div
    class="flex items-center gap-sm disabled"
    :class="slimline ? 'flex-col' : 'flex-row'"
  >
    <GrabHandleControl
      v-if="!slimline"
      :disabled="disabled"
      data-test="handle"
    />
    <div
      class="flex flex-col items-center"
      :class="{ 'gap-sm': slimline }"
    >
      <button
        @click="$emit('up')"
        class="chevron-button"
        :disabled="disabled"
        :aria-label="upButtonAriaLabel"
        data-test="up-button"
      >
        <ChevronUpIcon aria-hidden="true" />
      </button>
      <GrabHandleControl
        v-if="slimline"
        data-test="slimline-handle"
        class="!cursor-pointer"
      />
      <button
        @click="$emit('down')"
        class="chevron-button rotate-180"
        :disabled="disabled"
        :aria-label="downButtonAriaLabel"
        data-test="down-button"
      >
        <ChevronUpIcon aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { GrabHandleControl } from '@/components/library/controls/GrabHandleControl';
import { ChevronUpIcon } from '@/components/library/icons';

export default defineComponent({
  components: { GrabHandleControl, ChevronUpIcon },
  props: {
    slimline: {
      type: Boolean,
      default: false,
    },
    upButtonAriaLabel: {
      type: String,
      default: undefined,
      required: false,
    },
    downButtonAriaLabel: {
      type: String,
      default: undefined,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped>
.chevron-button {
  @apply flex items-center bg-transparent h-twentyTwo w-twentyTwo p-2 border-none
  text-signableBrandColours-midGrey hover:text-signableBrandColours-darkGrey disabled:text-signableBrandColours-midGrey
  cursor-pointer disabled:cursor-default;
}
</style>
